import Authentication from './SecondScreen';

export default Authentication;
